<p-calendar
  [placeholder]="placeholder"
  [dateFormat]="dateFormat"
  [firstDayOfWeek]="firstDayOfWeek"
  [inputStyleClass]="inputStyleClass"
  [disabledDays]="daysDisabled"
  [maxDate]="calendarMaxDate"
  [minDate]="calendarMinDate"
  [(ngModel)]="selectedDate"
  [appendTo]="appendTo"
  [readonlyInput]="readonlyInput"
  [disabled]="isDisabled"
  [showIcon]="showIcon"
  [icon]="icon"
  [showButtonBar]="showButtonBar"
  [showClear]="showClear"
  [keepInvalid]="true"
  [inline]="inline"
  [view]="view"
  [selectionMode]="selectionMode"
  [numberOfMonths]="numberOfMonths"
  [showWeek]="showWeek"
  (ngModelChange)="handleDateChange($event)"
  (onBlur)="onCalendarBlur()"
  (onClear)="clearDate()"
/>
